/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  firstName: null,
  lastName: null,
  userId: null,
  sessionId: null,
};

const emulatorSlice = createSlice({
  name: 'emulator',
  initialState,
  reducers: {
    setEmulator: (state, action) => {
      state.firstName = action.payload.first_name;
      state.lastName = action.payload.last_name;
      state.userId = action.payload.user_id;
      state.sessionId = action.payload.session_id;
    },
    clearEmulator: (state) => {
      state.firstName = initialState.firstName;
      state.lastName = initialState.lastName;
      state.userId = initialState.userId;
      state.sessionId = initialState.sessionId;
    },
  },
});

export const { setEmulator, clearEmulator } = emulatorSlice.actions;

export const emulatorSelector = (state) => state.emulator;

export default emulatorSlice.reducer;
